import { Box, Button, IconButton, Drawer, List, ListItemButton, ListItemIcon, ListItemText, Divider, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { rolesType } from "../../services/apiService";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';

const navBtnSx = (active) => ({
    color: active ? '#fff' : 'rgba(255,255,255,.72)',
    fontWeight: active ? 600 : 500,
    fontSize: '.85rem',
    textTransform: 'none',
    borderRadius: '8px',
    px: 1.75,
    py: 1,
    backgroundColor: active ? 'rgba(255,255,255,.12)' : 'transparent',
    '&:hover': { backgroundColor: 'rgba(255,255,255,.08)', color: '#fff' },
});

const mobileSectionLabelSx = {
    fontSize: '.72rem',
    fontWeight: 700,
    color: 'text.secondary',
    textTransform: 'uppercase',
    letterSpacing: '.05em',
    px: 2,
    pt: 2,
    pb: 0.5,
};

function Menus({ onLogoutClick }){
    const userId = localStorage.getItem("id");
    const [role,setRole] = useState('')
    const [anchorEl1, setAnchorEl1] = React.useState(null);
    const [anchorEl2, setAnchorEl2] = React.useState(null);
    const [anchorEl4, setAnchorEl4] = React.useState(null);
    const [mobileOpen, setMobileOpen] = useState(false);
    const open1 = Boolean(anchorEl1);
    const open2 = Boolean(anchorEl2);
    const open4 = Boolean(anchorEl4);
    const navigate = useNavigate();
    const location = useLocation();
    const isActive = (path) => location.pathname === path;
    const isAnyActive = (paths) => paths.some(isActive);

    const artifactsPaths = ['/asset/search', '/asset/upload', '/asset/manage'];
    const usersPaths = ['/users/upload', '/manage/buheads', '/users/manage'];
    const isArtifactsSectionActive = isAnyActive(artifactsPaths);
    const isUsersSectionActive = isAnyActive(usersPaths);

    const handleClick1 = (event) => {
        setAnchorEl1(event.currentTarget);
    };
    const handleClose1 = () => {
        setAnchorEl1(null);
    };

    const handleClick2 = (event) => {
        setAnchorEl2(event.currentTarget);
    };
    const handleClose2 = () => {
        setAnchorEl2(null);
    };

    const handleClick4 = (event) => {
        setAnchorEl4(event.currentTarget);
    };
    const handleClose4 = () => {
        setAnchorEl4(null);
    };

    const navigateAndClose = (route, closeMenu) => {
        closeMenu();
        navigate(route);
    };

    const handleMobileNavigate = (route) => {
        setMobileOpen(false);
        navigate(route);
    };

    const handleMobileLogout = () => {
        setMobileOpen(false);
        onLogoutClick?.();
    };

    useEffect(()=>{

        const fetchRole = async()=>{
                try{

                    const rolesResponse = await rolesType(userId);

                    const apiRole = rolesResponse?.data?.data.role_type; // Adjust the condition as needed
                    setRole(apiRole)

                }catch(error){

                }
        }
        fetchRole()

    },[])
    return(
        <>
        {/* Horizontal Menu — desktop/tablet only */}
        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, alignItems: 'center', marginLeft: 3.5 }} gap={0.5}>
                        {role === 2 &&( // User
                            <>
                            <Button size="small" component={Link} to="/asset/search" sx={navBtnSx(isActive('/asset/search'))}>Artifact Library</Button>
                            </>
                        )}

                        {role === 1 &&( // Admin User
                            <>
                            <Button size="small" component={Link} to="/admin/dashboard" sx={navBtnSx(isActive('/admin/dashboard') || isActive('/home'))}>Dashboard</Button>
                            <Button
                                size="small"
                                id="asset-basic-menu"
                                sx={navBtnSx(open2 || isArtifactsSectionActive)}
                                aria-controls={open2 ? 'asset-basic-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open2 ? 'true' : undefined}
                                onClick={handleClick2}
                                endIcon={<KeyboardArrowDownIcon sx={{ transform: open2 ? 'rotate(180deg)' : 'none', transition: 'transform .15s' }} />}
                            >
                                Artifacts
                            </Button>

                            <Menu
                                id="asset-basic-menu"
                                anchorEl={anchorEl2}
                                open={open2}
                                onClose={handleClose2}
                                MenuListProps={{
                                    'aria-labelledby': 'asset-basic-menu',
                                }}
                                >
                                <MenuItem onClick={() => navigateAndClose('/asset/search', handleClose2)}>Artifact Library</MenuItem>
                                <MenuItem onClick={() => navigateAndClose('/asset/upload', handleClose2)}>Create Artifact</MenuItem>
                                <MenuItem onClick={() => navigateAndClose('/asset/manage', handleClose2)}>Manage Artifacts</MenuItem>
                                <MenuItem onClick={() => navigateAndClose('/tags/manage', handleClose2)}>Manage Tags</MenuItem>
                            </Menu>

                            <Button size="small" component={Link} to="/asset/reports" sx={navBtnSx(isActive('/asset/reports'))}>Reports</Button>

                            <Button
                                size="small"
                                id="basic-button"
                                sx={navBtnSx(open1 || isUsersSectionActive)}
                                aria-controls={open1 ? 'basic-menus' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open1 ? 'true' : undefined}
                                onClick={handleClick1}
                                endIcon={<KeyboardArrowDownIcon sx={{ transform: open1 ? 'rotate(180deg)' : 'none', transition: 'transform .15s' }} />}
                            >
                                Users
                            </Button>

                            <Menu
                            id="basic-menus"
                            anchorEl={anchorEl1}
                            open={open1}
                            onClose={handleClose1}
                            MenuListProps={{
                                'aria-labelledby': 'basic-button',
                            }}
                            >
                            <MenuItem onClick={() => navigateAndClose('/users/upload', handleClose1)}>Bulk Upload</MenuItem>
                            <MenuItem onClick={() => navigateAndClose('/manage/buheads', handleClose1)}>Manage BU Heads</MenuItem>
                            <MenuItem onClick={() => navigateAndClose('/users/manage', handleClose1)}>User Management</MenuItem>

                            </Menu>

                            </>
                        )}

                        {role === 3 &&( // Contributor User
                            <>
                            <Button
                                size="small"
                                id="contributor-asset-basic-menu"
                                sx={navBtnSx(open4 || isArtifactsSectionActive)}
                                aria-controls={open4 ? 'contributor-asset-basic-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open4 ? 'true' : undefined}
                                onClick={handleClick4}
                                endIcon={<KeyboardArrowDownIcon sx={{ transform: open4 ? 'rotate(180deg)' : 'none', transition: 'transform .15s' }} />}
                            >
                                Artifacts
                            </Button>

                            <Menu
                                id="contributor-asset-basic-menu"
                                anchorEl={anchorEl4}
                                open={open4}
                                onClose={handleClose4}
                                MenuListProps={{
                                    'aria-labelledby': 'contributor-asset-basic-menu',
                                }}
                                >
                                <MenuItem onClick={() => navigateAndClose('/asset/search', handleClose4)}>Artifact Library</MenuItem>
                                <MenuItem onClick={() => navigateAndClose('/asset/upload', handleClose4)}>Create Artifact</MenuItem>
                                <MenuItem onClick={() => navigateAndClose('/asset/manage', handleClose4)}>Manage Artifacts</MenuItem>
                            </Menu>

                            <Button size="small" component={Link} to="/asset/reports" sx={navBtnSx(isActive('/asset/reports'))}>Reports</Button>
                            </>
                        )}

                    </Box>

        {/* Hamburger menu — mobile/small-tablet only, exposes every item the desktop nav has.
            Ordered last so it renders in the top-right corner, after the notification/account icons. */}
        <Box sx={{ flexGrow: { xs: 1, md: 0 }, display: { xs: 'flex', md: 'none' }, justifyContent: 'flex-end', order: { xs: 2, md: 0 } }}>
            <IconButton
                onClick={() => setMobileOpen(true)}
                aria-label="Open navigation menu"
                sx={{
                    width: 40,
                    height: 40,
                    color: 'rgba(255,255,255,.85)',
                    '&:hover': { backgroundColor: 'rgba(255,255,255,.1)', color: '#fff' },
                }}
            >
                <MenuIcon />
            </IconButton>
        </Box>

        <Drawer anchor="right" open={mobileOpen} onClose={() => setMobileOpen(false)}>
            <Box sx={{ width: 260 }} role="navigation" aria-label="Mobile navigation">
                <List disablePadding>
                    {role === 2 && (
                        <>
                            <ListItemButton selected={isActive('/asset/search')} onClick={() => handleMobileNavigate('/asset/search')}>
                                <ListItemText primary="Artifact Library" />
                            </ListItemButton>
                            <Divider />
                        </>
                    )}

                    {role === 1 && (
                        <>
                            <ListItemButton selected={isActive('/admin/dashboard') || isActive('/home')} onClick={() => handleMobileNavigate('/admin/dashboard')}>
                                <ListItemText primary="Dashboard" />
                            </ListItemButton>

                            <Typography sx={mobileSectionLabelSx}>Artifacts</Typography>
                            <ListItemButton selected={isActive('/asset/search')} onClick={() => handleMobileNavigate('/asset/search')}>
                                <ListItemText primary="Artifact Library" />
                            </ListItemButton>
                            <ListItemButton selected={isActive('/asset/upload')} onClick={() => handleMobileNavigate('/asset/upload')}>
                                <ListItemText primary="Create Artifact" />
                            </ListItemButton>
                            <ListItemButton selected={isActive('/asset/manage')} onClick={() => handleMobileNavigate('/asset/manage')}>
                                <ListItemText primary="Manage Artifacts" />
                            </ListItemButton>
                            <ListItemButton selected={isActive('/tags/manage')} onClick={() => handleMobileNavigate('/tags/manage')}>
                                <ListItemText primary="Manage Tags" />
                            </ListItemButton>

                            <Divider sx={{ mt: 1 }} />
                            <ListItemButton selected={isActive('/asset/reports')} onClick={() => handleMobileNavigate('/asset/reports')}>
                                <ListItemText primary="Reports" />
                            </ListItemButton>
                            <Divider />

                            <Typography sx={mobileSectionLabelSx}>Users</Typography>
                            <ListItemButton selected={isActive('/users/upload')} onClick={() => handleMobileNavigate('/users/upload')}>
                                <ListItemText primary="Bulk Upload" />
                            </ListItemButton>
                            <ListItemButton selected={isActive('/manage/buheads')} onClick={() => handleMobileNavigate('/manage/buheads')}>
                                <ListItemText primary="Manage BU Heads" />
                            </ListItemButton>
                            <ListItemButton selected={isActive('/users/manage')} onClick={() => handleMobileNavigate('/users/manage')}>
                                <ListItemText primary="User Management" />
                            </ListItemButton>
                        </>
                    )}

                    {role === 3 && (
                        <>
                            <Typography sx={mobileSectionLabelSx}>Artifacts</Typography>
                            <ListItemButton selected={isActive('/asset/search')} onClick={() => handleMobileNavigate('/asset/search')}>
                                <ListItemText primary="Artifact Library" />
                            </ListItemButton>
                            <ListItemButton selected={isActive('/asset/upload')} onClick={() => handleMobileNavigate('/asset/upload')}>
                                <ListItemText primary="Create Artifact" />
                            </ListItemButton>
                            <ListItemButton selected={isActive('/asset/manage')} onClick={() => handleMobileNavigate('/asset/manage')}>
                                <ListItemText primary="Manage Artifacts" />
                            </ListItemButton>

                            <Divider sx={{ mt: 1 }} />
                            <ListItemButton selected={isActive('/asset/reports')} onClick={() => handleMobileNavigate('/asset/reports')}>
                                <ListItemText primary="Reports" />
                            </ListItemButton>
                            <Divider />
                        </>
                    )}

                    {/* Logout — always the last item in the mobile navigation menu */}
                    <Divider />
                    <ListItemButton onClick={handleMobileLogout}>
                        <ListItemIcon sx={{ minWidth: 36 }}>
                            <LogoutIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary="Logout" />
                    </ListItemButton>
                </List>
            </Box>
        </Drawer>
        </>
    )
}
export default Menus;
